import React from 'react';
import { StyledRow } from './column/styled';

const Row = ({ gap, marginBottom, matchHeight, children, center, maxWidth }) => {
  return <StyledRow center={center} maxWidth={maxWidth} gap={gap} matchHeight={matchHeight} marginBottom={marginBottom}>{children}</StyledRow>
};

export default Row;